type useIsTouchDeviceReturnValue = boolean;

export const useIsTouchDevice = (): useIsTouchDeviceReturnValue => {
  return window.matchMedia("(pointer: coarse)").matches;
};
